module.exports = __webpack_public_path__ + "Cancel-db987d21c82708344385.png";